module.exports = __webpack_public_path__ + "static/img/samsung.709e639.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samsung.jpg
// module id = oDWt
// module chunks = 1